import { GET_COMMUNICATION_LIST_SUCCESS } from "../action-types/communication";

const initialState = {
    communications: []
};

const communicationReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_COMMUNICATION_LIST_SUCCESS:
            return {
                ...state,
                communications: action.communications.records
            };
        default:
            return state;
    }
}

export default communicationReducer;